<template>
  <div>
    <v-dialog
      v-model="AgoraCallDialog"
      width="500"
      persistent
    >
      <v-card style="height: 350px !important;">
        <v-card-text>
          <v-layout column wrap justify-center align-center style="height: 230px !important;">
            <v-avatar
              :size="100"
            >
            <img :src="infor_call.picture" class="img-w-h" v-if="infor_call.picture">
            <img src="/static/img/default_profile/bot-white.png" class="img-w-h" v-else>
            </v-avatar>
            <h2 class="text-overflow mt-3">{{infor_call.nickname}}</h2>
          </v-layout>
          <v-layout row wrap justify-center align-center>
            <v-btn class="border-radius text-transform" color="primary" @click="accept_call()">{{$t('ChatSide.conference.joinCall')}}</v-btn>
            <v-btn class="border-radius text-transform" dark color="red" @click="closedialog()">{{$t('AnswerQuestion.cancel')}}</v-btn>
          </v-layout>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- <audio src="/static/sound/sound_1.mp3" id="soundRingtone" loop autoplay></audio> -->
    <!-- <audio src="/static/sound/sound_3.wav" id="soundRingtone2" loop></audio> -->
    <audio id="soundRingtone" loop>
      <source src="/static/sound/sound_1.mp3" type="audio/mpeg">
    </audio>
  </div>
</template>
<script>
import { Encode } from '@/services'
export default {
  props: {
    AgoraCallDialog: Boolean,
    infor_call: {},
    tokenuser: String,
    AgoraOption: String
  },
  data () {
    return {
    }
  },
  watch: {
    AgoraCallDialog () {
      var soundRingtone = document.getElementById('soundRingtone')
      if (this.AgoraCallDialog) {
        console.log(this.infor_call)
        // soundRingtone.currentTime = 0
        // soundRingtone.autoplay;
        soundRingtone.currentTime = 0
        soundRingtone.play()
        // soundRingtone.loop = true
      } else {
        soundRingtone.currentTime = 0
        soundRingtone.pause()
      }
    }
  },
  methods: {
    closedialog () {
      var soundRingtone = document.getElementById('soundRingtone')
      soundRingtone.pause()
      soundRingtone.currentTime = 0
      // this.$emit('decline_call', this.infor_call)
      this.$emit('closeAgoraDialog', false)
    },
    accept_call () {
      window.open(`/chat/room/call/${this.AgoraOption}/?token=${Encode.encodeToken(this.infor_call.agora_token)}&channel_name=${Encode.encodeToken(this.infor_call.channel)}&user_infor=${Encode.encode(this.infor_call)}`, '_blank')
      this.$emit('closeAgoraDialog', false)
      var soundRingtone = document.getElementById('soundRingtone')
      soundRingtone.pause()
      soundRingtone.currentTime = 0
      // this.axios.post(process.env.APIalpine + `/api/v1/join-agora`, {
      //   tokenroom: this.infor_call.tokenroom,
      //   tokenmessage: this.infor_call.tokenmessage,
      //   tokenuser: this.tokenuser
      // }).then((response) => {
      //   this.$emit('closeAgoraDialog', false)
      //   window.open(`/chat/room/${this.AgoraOption}/${this.infor_call.tokenroom}/?token=${Encode.encodeToken(response.data.token)}&channel_name=${Encode.encodeToken(this.infor_call.tokenmessage)}`, '_blank')
      // }).catch(error => {
      //   console.log(error)
      // })
    }
  }
}
</script>
<style media="screen" scroped>
.text-transform {
  text-transform: none;
}
.img-w-h {
  object-fit: cover;
  object-position: 50% 40%;
  height: 150px;
  width: 100%;
}
.text-overflow {
  max-width: 400px !important;
  text-overflow: ellipsis !important;
  white-space: nowrap !important;
  overflow: hidden !important;
}
.border-radius {
  border-radius: 20px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/chat/agora_call/ans_call_v2.vue